import * as Icons from "lucide-react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ServiceCard({ service }) {
  const Icon = Icons[toPascal(service.icon)] || Icons.BookOpen;
  return (
    <Link
      to={`/services/${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      className="card-flat group flex flex-col"
    >
      <div className="w-12 h-12 flex items-center justify-center border border-slate-200 rounded-sm mb-4 group-hover:border-gold group-hover:bg-gold/5 transition">
        <Icon className="w-5 h-5 text-navy" />
      </div>
      <h3 className="font-display text-2xl leading-tight mb-2">{service.title}</h3>
      <p className="text-sm text-slate-600 mb-6 flex-1">{service.tagline}</p>
      <div className="mt-auto flex items-center justify-between text-sm">
        <span className="section-eyebrow">Get Started</span>
        <ArrowUpRight className="w-4 h-4 text-royal group-hover:text-gold transition-colors" />
      </div>
    </Link>
  );
}

function toPascal(kebab) {
  return kebab.split("-").map((s) => s[0].toUpperCase() + s.slice(1)).join("");
}
